export default __webpack_public_path__ + "static/media/icon_file-pdf.0bc4b3c1.svg";